import { STATISTICS_INIT_LOADING, STATISTICS_INIT_SUCCESS, STATISTICS_INIT_FAIL } from '@/store/types'

export const statistics = {
  [STATISTICS_INIT_LOADING](state) {
    state.statistics.init = 0
    state.statistics.initErr = []
    state.statistics.menu = {}
  },
  [STATISTICS_INIT_SUCCESS](state, data) {
    state.statistics.init = 1
    state.statistics.initErr = []
    state.statistics.menu = data.menu
  },
  [STATISTICS_INIT_FAIL](state, error) {
    state.statistics.init = 2
    state.statistics.initErr = error
    state.statistics.menu = {}
  }
}
